// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   Troly · Onyx Club — Compartir perfil
   Tokens \`--troly-*\` únicamente. Base 360px (PWA 9:16), sin
   interacciones hover-only y touch targets ≥ 44px.
   ───────────────────────────────────────────────────────────── */

.share {
  position: relative;
  display: inline-flex;
}

.share__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  min-width: 44px;
  padding: 0 16px;
  border: 1px solid var(--troly-border-strong);
  border-radius: var(--troly-radius-md);
  background: transparent;
  color: var(--troly-fg);
  font-family: var(--troly-font-body);
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  transition: border-color .18s, color .18s;
}

.share__trigger:focus-visible,
.share__trigger[aria-expanded="true"] {
  border-color: var(--troly-action);
  color: var(--troly-action);
  outline: none;
}

.share__menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 60;
  min-width: 232px;
  padding: 8px;
  border: 1px solid var(--troly-border);
  border-radius: var(--troly-radius-lg);
  background: var(--troly-bg-elevated);
  box-shadow: 0 12px 32px rgba(0, 0, 0, .28);
}

.share__menu-title {
  display: block;
  padding: 6px 10px 8px;
  font-family: var(--troly-font-body);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--troly-fg-subtle);
}

.share__item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 44px;
  padding: 0 10px;
  border: none;
  border-radius: var(--troly-radius-md);
  background: transparent;
  color: var(--troly-fg);
  font-family: var(--troly-font-body);
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  text-decoration: none;
  transition: background .16s;
}

.share__item:focus-visible { outline: 2px solid var(--troly-action); outline-offset: -2px; }
.share__item:active        { background: var(--troly-border); }

@media (hover: hover) {
  .share__item:hover { background: var(--troly-border); }
}

.share__item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: var(--troly-radius-pill);
  background: var(--troly-border);
  color: var(--troly-fg-muted);
}

.share__item--done .share__item-icon { color: var(--troly-action); }

@media (max-width: 479px) {
  .share__menu { left: auto; right: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShareProfile.css"],"names":[],"mappings":"AAAA;;;;kEAIkE;;AAElE;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4CAA4C;EAC5C,qCAAqC;EACrC,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,6BAA6B,sCAAsC,EAAE,oBAAoB,EAAE;AAC3F,6BAA6B,+BAA+B,EAAE;;AAE9D;EACE,qBAAqB,+BAA+B,EAAE;AACxD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,uCAAuC,0BAA0B,EAAE;;AAEnE;EACE,eAAe,UAAU,EAAE,QAAQ,EAAE;AACvC","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   Troly · Onyx Club — Compartir perfil\n   Tokens `--troly-*` únicamente. Base 360px (PWA 9:16), sin\n   interacciones hover-only y touch targets ≥ 44px.\n   ───────────────────────────────────────────────────────────── */\n\n.share {\n  position: relative;\n  display: inline-flex;\n}\n\n.share__trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  min-width: 44px;\n  padding: 0 16px;\n  border: 1px solid var(--troly-border-strong);\n  border-radius: var(--troly-radius-md);\n  background: transparent;\n  color: var(--troly-fg);\n  font-family: var(--troly-font-body);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  transition: border-color .18s, color .18s;\n}\n\n.share__trigger:focus-visible,\n.share__trigger[aria-expanded=\"true\"] {\n  border-color: var(--troly-action);\n  color: var(--troly-action);\n  outline: none;\n}\n\n.share__menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: 60;\n  min-width: 232px;\n  padding: 8px;\n  border: 1px solid var(--troly-border);\n  border-radius: var(--troly-radius-lg);\n  background: var(--troly-bg-elevated);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, .28);\n}\n\n.share__menu-title {\n  display: block;\n  padding: 6px 10px 8px;\n  font-family: var(--troly-font-body);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n  color: var(--troly-fg-subtle);\n}\n\n.share__item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-height: 44px;\n  padding: 0 10px;\n  border: none;\n  border-radius: var(--troly-radius-md);\n  background: transparent;\n  color: var(--troly-fg);\n  font-family: var(--troly-font-body);\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left;\n  text-decoration: none;\n  transition: background .16s;\n}\n\n.share__item:focus-visible { outline: 2px solid var(--troly-action); outline-offset: -2px; }\n.share__item:active        { background: var(--troly-border); }\n\n@media (hover: hover) {\n  .share__item:hover { background: var(--troly-border); }\n}\n\n.share__item-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  border-radius: var(--troly-radius-pill);\n  background: var(--troly-border);\n  color: var(--troly-fg-muted);\n}\n\n.share__item--done .share__item-icon { color: var(--troly-action); }\n\n@media (max-width: 479px) {\n  .share__menu { left: auto; right: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
